import { Avatar, Box, Link, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';

import { MessageContainer, MessageBox, MessageDetails, TimeStamp } from './style';
import { MessageProps } from './types';

export const Message = ({ message, isOwnMessage }: MessageProps) => {
  const renderFileAttachment = () => {
    if (!message.filename || !message.filepath || !message.filetype) return null;

    if (message.filetype.startsWith('image/')) {
      return (
        <Box sx={{ marginTop: 2 }}>
          <Link href={message.filepath} target="_blank" rel="noopener noreferrer">
            <img
              src={message.filepath}
              alt={'Error'}
              style={{ maxWidth: '100%', maxHeight: '150px' }}
            />
          </Link>
        </Box>
      );
    }

    if (message.filetype.startsWith('video/')) {
      return (
        <Box sx={{ marginTop: 2 }}>
          <Link href={message.filepath} target="_blank" rel="noopener noreferrer">
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              src={message.filepath}
              controls
              style={{ maxWidth: '100%', maxHeight: '150px' }}
            />
          </Link>
        </Box>
      );
    }

    if (message.filetype === 'application/pdf') {
      return (
        <Box sx={{ marginTop: 2 }}>
          <Link href={message.filepath} target="_blank" rel="noopener noreferrer">
            <Typography>View PDF: {message.filename}</Typography>
          </Link>
        </Box>
      );
    }

    return null;
  };

  return (
    <MessageContainer isOwnMessage={isOwnMessage}>
      <MessageBox isOwnMessage={isOwnMessage}>
        <Typography sx={{ padding: 2 }}>{message.message}</Typography>
        {renderFileAttachment()}
      </MessageBox>
      <MessageDetails>
        {isOwnMessage ? null : (
          <Avatar alt={message.sender.firstName[0]} src={message.sender.fullImageUrl} />
        )}
        <TimeStamp>{dayjs(message.timestamp).format('MMM D,YYYY - h:mm A')}</TimeStamp>
      </MessageDetails>
    </MessageContainer>
  );
};
